import React, { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { useTranslation } from "react-i18next"

import { Dimmer, Segment, Sidebar } from "semantic-ui-react"

import { hasEnoughPermissions } from "../config/permissions"
import { selectStore, signOut } from "../ducks/profile"
import { closeMessage } from "../ducks/alerts"

import AlertsHolder from "../components/AlertsHolder"
import LoginPage from "./LoginPage"
import SidebarMenu from "../components/SidebarMenu"
import { SidebarMenuItem, sidebarMenuItems } from "../config/sidebarMenuItems"
import TopMenu from "../components/TopMenu"
import RegisterPage from "./RegisterPage"
import RecoverPage from "./RecoverPage"

const Layout = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { t } = useTranslation()

  const { profile, alerts } = useSelector((state) => ({
    profile: state.profile,
    alerts: state.alerts,
  }))

  const [sidebarOpened, setSidebarOpened] = useState(false)

  useEffect(() => {
    return () => {}
  }, [])

  const toggleSidebar = () => {
    setSidebarOpened(!sidebarOpened)
  }

  const navigateHome = () => {
    history.push("/")
    setSidebarOpened(false)
  }

  const handleLink = () => {
    window.open("https://smartkassa.kz/excise/")
  }

  const onSignOut = () => {
    dispatch(signOut())
  }

  const onAlertClick = (id) => {
    dispatch(closeMessage(id))
  }

  const onStoreSelected = (id) => {
    dispatch(selectStore(id))
  }

  const { children } = props

  const { pathname } = useLocation()

  if (!profile.signedIn) {
    return (
      <div>
        <AlertsHolder top alerts={alerts} onAlertClick={onAlertClick} />
        {pathname === "/register" ? (
          <RegisterPage />
        ) : pathname === "/recover" ? (
          <RecoverPage />
        ) : (
          <>
            <LoginPage />
          </>
        )}
      </div>
    )
  }
  const sidebarMenuItemsList = sidebarMenuItems.filter((item) =>
    hasEnoughPermissions(profile.permissions, item.route.permissions),
  )
  if (profile.isUkm) {
    sidebarMenuItemsList.push(
      new SidebarMenuItem(null, "УКМ", null, handleLink),
      new SidebarMenuItem(null, t("logout"), null, onSignOut),
    )
  } else {
    sidebarMenuItemsList.push(
      new SidebarMenuItem(null, t("logout"), null, onSignOut),
    )
  }

  return (
    <div>
      <TopMenu
        logoImg={require("../assets/img/logo.png")}
        logoTitle="Smartkassa"
        profile={profile}
        toggleSidebar={toggleSidebar}
        onSignOut={onSignOut}
        navigateHome={navigateHome}
        onStoreSelected={onStoreSelected}
      />
      <div className="page-container">
        <Sidebar.Pushable as="div">
          <SidebarMenu
            visible={sidebarOpened}
            menuItems={sidebarMenuItemsList}
            toggleSidebar={toggleSidebar}
          />
          <Sidebar.Pusher>
            <Segment basic>
              <AlertsHolder alerts={alerts} onAlertClick={onAlertClick} />
              {children}
            </Segment>
            <Dimmer
              className="sidebar-dimmer"
              active={sidebarOpened}
              onClick={toggleSidebar}
            />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    </div>
  )
}

export default Layout
